import React, { useState } from 'react';
import { useHistory } from 'react-router';
import AddProjectDomainDialog from '../../components/muiLegacy/Dialogs/AddDomainDialog/AddProjectDomainDialog';
import VoxelAlert from '../../components/voxel/Alert/VoxelAlert';
import VoxelPageContainer from '../../components/voxel/Containers/VoxelPageContainer';
import { DomainTypeGq } from '../../graphql/projects/models/DomainTypeGq';
import { ProjectGq } from '../../graphql/projects/models/ProjectGq';
import { CurrentUserGq } from '../../graphql/users/models/CurrentUserGq';
import ProjectAppBar from '../ProjectPage/ProjectAppBar/ProjectAppBar';
import { ProjectTabChoices } from '../ProjectPage/ProjectPage';

export interface MissingRankDomainPageProps {
  project: ProjectGq;
  user: CurrentUserGq;
  reload: () => Promise<unknown>;
  noDomain?: boolean;
  noRankData?: boolean;
}

const MissingRankDomainPage: React.FC<MissingRankDomainPageProps> = ({
  project,
  reload,
  user,
  noDomain,
  noRankData,
}) => {
  // Add domain
  const [addDomainOpen, setAddDomainOpen] = useState<DomainTypeGq | null>(null);
  const history = useHistory();

  return (
    <>
      <ProjectAppBar project={project} user={user} />
      <VoxelPageContainer>
        <div className="mt-24 mx-auto max-w-3xl flex flex-col justify-center items-center gap-6">
          {noDomain && (
            <VoxelAlert
              severity='info'
              onClickTitle='Add domain'
              onClick={() => setAddDomainOpen(DomainTypeGq.PROJECT)}
            >
              The rank tracking feature requires that you have added a project domain
            </VoxelAlert>
          )}
          {noRankData && (
            <VoxelAlert
              severity='info'
              onClickTitle='Add rank data'
              onClick={() => history.push(`/${project.id}/${ProjectTabChoices.Manage}/fetchRankData`)}
            >
              The rank tracking feature requires that you have added rank data
            </VoxelAlert>
          )}
        </div>
      </VoxelPageContainer>
      {addDomainOpen !== null && addDomainOpen === DomainTypeGq.PROJECT && (
        <AddProjectDomainDialog
          project={project}
          onSuccess={(domainId) =>
            reload().then(() => {
              setAddDomainOpen(null);
            })
          }
          close={() => {
            setAddDomainOpen(null);
          }}
        />
      )}
    </>
  );
};

export default MissingRankDomainPage;
